import React, { useEffect, useState } from "react";
import { RouteComponentProps } from "react-router-dom";
import { useSelector } from "react-redux";
import { CTooltip } from "@coreui/react";
import { Content, Sidebar, Footer, Header } from "./index";
import FloatingButtonExpanded from "./FloatingButtonExpanded";
import DemoWelcomeModal from "./DemoWelcomeModal";
import { RootState } from "../../store";

const demoModalKey = (id: number) => `demo_welcome_dismissed_${id}`;

const Layout: React.FunctionComponent<RouteComponentProps> = () => {
  const taxPayer = useSelector(
    (state: RootState) => state.taxPayer.data.taxPayer
  );
  const [showDemoModal, setShowDemoModal] = useState(false);

  useEffect(() => {
    if (taxPayer.isDemo && taxPayer.id) {
      const dismissed = localStorage.getItem(demoModalKey(taxPayer.id));
      if (!dismissed) {
        setShowDemoModal(true);
      }
    }
  }, [taxPayer.id, taxPayer.isDemo]);

  const handleDismissModal = () => {
    if (taxPayer.id) {
      localStorage.setItem(demoModalKey(taxPayer.id), "true");
    }
    setShowDemoModal(false);
  };

  return (
    <div className="c-app c-default-layout">
      <Sidebar />
      <div className="c-wrapper">
        <Header />
        {taxPayer.isDemo && (
          <div className="demo-banner">
            <CTooltip
              content="Los documentos generados en el ambiente de demo no tienen validez fiscal"
              placement="bottom"
            >
              <i className="fa fa-info-circle mr-2" style={{ cursor: "default" }} />
            </CTooltip>
            Esta es una versión demo
            <span style={{ fontWeight: "normal", marginLeft: "6px" }}>
              (válida por {process.env.REACT_APP_DEMO_DURATION_DAYS ?? "7"} días)
            </span>
            <button
              onClick={() => setShowDemoModal(true)}
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                fontWeight: "bold",
                textDecoration: "underline",
                marginLeft: "10px",
                padding: 0,
                fontSize: "inherit",
              }}
            >
              Ver más
            </button>
          </div>
        )}
        <div className="c-body">
          <Content />
        </div>
        <Footer />
      </div>
      <FloatingButtonExpanded />
      {taxPayer.isDemo && (
        <DemoWelcomeModal show={showDemoModal} onClose={handleDismissModal} />
      )}
    </div>
  );
};

export default Layout;
